function initLPFeedbacksProfessional(id = '') {
  const elemLPFeedbacksProfessional = document.getElementById(id);
  console.log(elemLPFeedbacksProfessional);

  if (elemLPFeedbacksProfessional) {
    console.log('aqui');

    new Swiper(elemLPFeedbacksProfessional.querySelector('.swiper'), {
      slidesPerView: 1,
      effect: 'fade',
      crossFade: true,
      speed: 1000,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'custom',
        renderCustom: function (swiper, current, total) {
          return `<span class="swp-custom">${current}/${total}</span>`;
        }
      }
    });
  }
}
